$("#flt-btn-wrapper").show();
$(".modal__close").click(function () {
  $("#flt-btn-wrapper").show();
  $("#NewsletterPopup-newsletter-popup").hide();
});
$(".text-close").click(function () {
  $("#flt-btn-wrapper").show();
  $("#NewsletterPopup-newsletter-popup").hide();
});
$("#flt-btn-wrapper").click(function () {
  $("#flt-btn-wrapper").hide();
});

/* blog slider js  */

$(".blog-carousel").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrow: "true",

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 500,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrow: false,
        autoplay: true,
        speed: 500,
      },
    },
  ],
});

$(".nh-twt-slider").slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: true,
  arrow: "false",

  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick",
    },

    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrow: false,
      },
    },
  ],
});

$(".company-logos").slick({
  infinite: true,
  speed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrow: false,

  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick",
    },

    {
      breakpoint: 600,
      settings: {
        autoplay: true,
        speed: 500,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        arrow: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        autoplay: true,
        speed: 2500,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        arrow: false,
      },
    },
  ],
});

$(".items-list-subcontainer1").slick({
  infinite: true,
  speed: 500,
  slidesToShow: 12,
  slidesToScroll: 12,
  dots: false,
  arrow: false,
  draggable: false,
  touchMove: false,

  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick",
    },

    {
      breakpoint: 600,
      settings: {
        autoplay: false,
        speed: 500,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrow: true,
        draggable: false,
        touchMove: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        autoplay: false,
        speed: 500,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrow: true,
        draggable: false,
        touchMove: false,
      },
    },
  ],
});

var width = $(window).width();
if (width < 640) {
  $(".blog-list-grid").slick({
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrow: true,
  });
}

$(".collection-slider").slick({
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: true,
  speed: 1000,
  responsive: true,
  slidesToScroll: 1,
  slidesToShow: 3, //show item
  centerMode: false,
  centerPadding: "0px",

  responsive: [
    {
      breakpoint: 1030,
      settings: {
        centerMode: false,
        centerPadding: "0px",
        slidesToScroll: 1,
        slidesToShow: 3, //show item
        arrows: true,
        dots: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: false,
        centerPadding: "0px",
        slidesToShow: 1, //show item
        dots: false,
        arrows: true,
      },
    },
  ],
});

//$('.collection-slider').slick('setPosition');
/* Team Testimonial Slider*/

$(".team-testimonial-slider").slick({
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: false,
  speed: 1000,
  responsive: true,
  slidesToScroll: 1,
  slidesToShow: 1, //show item
  centerMode: false,
  centerPadding: "0px",

  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: false,
        centerPadding: "0px",
        arrow: false,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infiinte: true,
        centerMode: false,
        centerPadding: "0px",
        arrow: false,
        dots: true,
      },
    },
  ],
});

//timeLine slider

$(".loading-bar").slick({
  centerMode: true,
  dots: true,
  arrows: false,
  infinite: true,
  speed: 1500,
  slidesToShow: 6,
  slidesToScroll: 1,
  focusOnSelect: true,
  autoplay: true,
  asNavFor: ".labels",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: "0px",
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: "0px",
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: "0px",
        autoplay: true,
        speed: 1500,
        dots: true,
      },
    },
  ],
});

$(".labels").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  draggable: false,
  asNavFor: ".loading-bar",
});

// New Pdp slider

$(".productlisting-slider").slick({
  arrows: true,
  autoplay: true,
  autoplaySpeed: 2000,
  infinite: true,
  speed: 1500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      },
    },
  ],
});

$(".desktopsliderpurity").slick({
  arrows: false,
  dots: true,
  infinite: false,
  speed: 800,
  slidesToShow: 4,
  slidesToScroll: 1,
});

if ($(window).width() < 600) {
  $(".doctor-expertise-mobile-container .doctor-expertise-points").slick({
    arrows: false,
    dots: true,
    infinite: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
}

$(".mobile-bannerSld").slick({
  arrows: true,
  dots: false,
  infinite: false,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick",
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      },
    },
  ],
});

//Testimonial videos slider
$(".testimonial-card").slick({
  arrows: true,
  infinite: true,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: "0px",
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      },
    },
  ],
});

// custom related product slider
$(".customrelated-slider").slick({
  arrows: true,
  infinite: false,
  speed: 800,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: "0px",
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
});

/* Load more button on colelction page chnages */
$(document).ready(function () {
  //show more option
  var size_item = $(".grid-product").length;
  var v = 9;
  $(".grid-product").hide(); // hide all divs with class `listing`
  $(".grid-product:lt(" + v + ")").show();
  $("#load_more").click(function () {
    v = v + 9 <= size_item ? v + 9 : size_item;
    $(".grid-product:lt(" + v + ")").show();
    // hide load more button if all items are visible
    if ($(".grid-product:visible").length >= size_item) {
      $("#load_more").hide();
    }
  });
});

var mobile = /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(
  navigator.userAgent.toLowerCase()
);
if (mobile) {
  $(".item-list-divider").hide(); // OR you can use $('.navWrap').hide();
}

if ($(window).width() < 600) {
  $(".moreless-button").click(function () {
    $(".moreless-button").hide();
    $(".moretext").slideToggle();
  });
} else {
}

win_wd = $(window).width();
var navHt = $("#SiteHeader").outerHeight();

$(".scroll_top").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".about-rich-text-section").offset().top - navHt,
    },
    700
  );
});

if (
  window.location.href ==
  "https://www.nisargaherbs.com/pages/doctor-consulation"
) {
  $("#flt-btn-wrapper").hide();
}

if (
  window.location.href ==
  "https://www.nisargaherbs.com/pages/virtual-consultation"
) {
  $("#flt-btn-wrapper").hide();
}

if (window.location.href == "https://www.nisargaherbs.com/pages/quiz") {
  $("#flt-btn-wrapper").hide();
}

// variant change js
$(".variant-btn").on("click", function () {
  console.log("selected qunatatit: ", event.target);
  if (event.target.value == "Pack Of 1") {
    console.log("event.target.value: ", event.target.value);
    $(".S2").removeClass("active");
    $(".S3").removeClass("active");
    $(".S1").removeClass("active");
  }
  if (event.target.value == "Pack Of 2") {
    console.log("event.target.value: ", event.target.value);
    $(".S2").addClass("active");
    $(".S3").removeClass("active");
    $(".S1").removeClass("active");
  }
  if (event.target.value == "Pack Of 3") {
    console.log("event.target.value: ", event.target.value);
    $(".S2").removeClass("active");
    $(".S3").addClass("active");
    $(".S1").removeClass("active");
  }
  if (event.target.value == "Strip Of 10") {
    console.log("event.target.value: ", event.target.value);
    $(".S2").removeClass("active");
    $(".S3").removeClass("active");
    $(".S1").removeClass("active");
  }
});

// $('#custprc-7327556665514 span').html('Starting from Rs 210.00');

$(document).ready(function () {
  $(".product-main-slide.starting-slide.is-selected").append(
    '<img alt="medicine icon" loading="lazy" class="medicineIcon mob" src="https://cdn.shopify.com/s/files/1/0073/9462/3539/files/stamonew.png?v=1670858424">'
  );

  var onnochange = $(".testproduct__price")
    .text()
    .replace("Rs.", "")
    .replace(",", "");

  if (onnochange > 500.0) {
    $("#overprice").html("Free Shipping");
  } else {
    $("#overprice").html("Free Shipping above" + " <span>Rs. 500</span>");
  }

  $(".variant-btn").on("change", function () {
    let testProductprice = $(".testproduct__price").text();
    let value = testProductprice.replace("Rs.", "").replace(",", "");
    if (value > 500.0) {
      $("#overprice").html("Free Shipping");
    } else {
      $("#overprice").html("Free Shipping above" + " <span>Rs. 500</span>");
    }
  });

  var WinHt = $(window).width();
  if (WinHt < 767) {
    $(".inner-badge.doctorlink").click(function () {
      $("html,body").animate(
        {
          scrollTop: $(".youtube-mobile").offset().top - 80,
        },
        "slow"
      );
    });
  } else {
    $(".doctorlink").click(function () {
      $("html,body").animate(
        {
          scrollTop: $(".youtube-desk").offset().top - 110,
        },
        "slow"
      );
    });
  }

  $(".inner-badge.patentedlink").click(function () {
    $("html,body").animate(
      {
        scrollTop: $(".mentalhealth-section").offset().top - 80,
      },
      "slow"
    );
  });

  var player;
  var tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  $("#Drvideo-btn").click(function (ev) {
    var img = document.getElementById("youtubeThumbnail1");
    var imgId = $("#youtubeThumbnail1").attr("id");
    var videoId = $("#youtubeThumbnail1").attr("data-video-id");
    //or however you get a handle to the IMG
    var iframe_width = img.clientWidth;
    var iframe_height = img.clientHeight;
    player = new YT.Player(imgId, {
      height: iframe_height,
      width: iframe_width,
      videoId: videoId,
      rel: 0,
      playerVars: {
        //autoplay: 1,
        playsinline: 1,
        rel: 0,
      },
      events: {
        onReady: onPlayerReady,
        //'onStateChange': onPlayerStateChange
      },
    });

    $(".youtube-mobile").hide();
    $(".innerVideocontainer").hide();
    $(".youtube_thumb").remove();
    function onPlayerReady() {
      player.playVideo();
    }
  });

  $("#Component_4_2").mouseover(function () {
    $(".comnum").show();
    $("#Icon_awesome-info-circle").hide();
  });
  $("#Component_4_2").mouseleave(function () {
    $(".comnum").hide();
    $("#Icon_awesome-info-circle").show();
  });

  $(".sticky-bar-buy").click(function (e) {
    e.preventDefault();
    $(".shopify-payment-button__button").click();
  });

  $(".addcartonmb").click(function (e) {
    e.preventDefault();
    $("#AddToCart").click();
  });

  $("#StickyHeaderWrap").css("height", "100px !important");
  if ($(".drawer").hasClass("drawer--is-open")) {
    console.log("open");
    $("#flt-btn-wrapper").css("display", "none");
  } else {
    $("#flt-btn-wrapper").css("display", "block");
  }
});

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

//mobile search bar show hide code
var WinHt = $(window).width();
if (WinHt < 767) {
  $(".js-search-header").hide();
  var $div = $("#searchbar2");
  var hidden = false;

  $(window).scroll(function () {
    if ($(this).scrollTop() > 0 && !hidden) {
      $div.hide();
      hidden = true;
    } else if ($(this).scrollTop() <= 0 && hidden) {
      $div.show();
      hidden = false;
    }

    if ($(this).scrollTop() > 0) {
      $(".js-search-header").show();
    } else if ($(this).scrollTop() <= 0) {
      $(".js-search-header").hide();
    }
  });
} else {
  $("#searchbar2").hide();
  $(".js-search-header").show();
}

// $(document).ready(function(){
//   setTimeout(function(){
//    var reviewText = $('.template-product .product-single__meta .spr-badge-caption').text().replace("based on Amazon & 1mg", " ");
//     //console.log(reviewText);
//     $('.template-product .product-single__meta .spr-badge-caption').html(reviewText);
//   },3000);
// });

$(document).ready(function () {
  setTimeout(function () {
    $(".items .item").each(function () {
      var freeholiprd = $(this).attr("data-variant-id");
      console.log(freeholiprd);

      if (freeholiprd == 44466869665962) {
        console.log("hello");
        $(this).addClass("freeholi");
        $(".item.freeholi").css("pointer-events", "none");
      }
    });
  }, 3000);
});

// #NISA-DEV-174 Append UTM Parameters to Product page 28 Jun 2023

function getUTMParameters() {
  var utmParameters = {};

  var queryString = window.location.search.substr(1);
  var params = queryString.split("&");

  for (var i = 0; i < params.length; i++) {
    var param = params[i].split("=");
    var key = decodeURIComponent(param[0]);
    var value = decodeURIComponent(param[1]);

    if (
      key === "utm_source" ||
      key === "utm_medium" ||
      key === "utm_campaign"
    ) {
      utmParameters[key] = value;
    }
  }

  console.log("---utmParameters,", utmParameters);
  return utmParameters;
}

function setUTMCookie(utmParameters) {
  // var expirationDate = new Date();
  // expirationDate.setMonth(expirationDate.getMonth() + 1);

  // for (var key in utmParameters) {
  //   if (utmParameters.hasOwnProperty(key)) {
  //     document.cookie = key + '=' + encodeURIComponent(utmParameters[key]) + '; expires=' + expirationDate.toUTCString() + '; path=/';
  //   }
  // }

  for (var key in utmParameters) {
    if (utmParameters.hasOwnProperty(key)) {
      // document.cookie = key + '=' + encodeURIComponent(utmParameters[key]) + '; expires=' + expirationDate.toUTCString() + '; path=/';
      console.log(key, encodeURIComponent(utmParameters[key]));
      sessionStorage.setItem(key, encodeURIComponent(utmParameters[key]));
    }
  }
}

function getUTMFromCookies() {
  // var utmParameters = {};

  // var cookies = document.cookie.split(';');
  // for (var i = 0; i < cookies.length; i++) {
  //   var cookie = cookies[i].trim().split('=');
  //   var key = decodeURIComponent(cookie[0]);
  //   var value = decodeURIComponent(cookie[1]);

  //   if (key === 'utm_source' || key === 'utm_medium' || key === 'utm_campaign') {
  //     utmParameters[key] = value;
  //   }
  // }
  var utmParameters = {
    utm_source: sessionStorage.getItem("utm_source"),
    utm_medium: sessionStorage.getItem("utm_medium"),
    utm_campaign: sessionStorage.getItem("utm_campaign"),
  };
  return utmParameters;
  // console.log("get utm :",sessionStorage.getItem('utmParameters'))

  // return sessionStorage.getItem('utmParameters')
}

var utmParams = getUTMParameters();
setUTMCookie(utmParams);

var utmParamsFromCookies = getUTMFromCookies();

var utmSource = utmParamsFromCookies.utm_source;
var utmMedium = utmParamsFromCookies.utm_medium;
var utmCampaign = utmParamsFromCookies.utm_campaign;

function appendUTMToURL(utmParameters) {
  var url = window.location.href;
  var queryString = "";

  for (var key in utmParameters) {
    if (utmParameters.hasOwnProperty(key)) {
      if (queryString === "") {
        queryString += "?";
      } else {
        queryString += "&";
      }
      queryString += key + "=" + encodeURIComponent(utmParameters[key]);
    }
  }

  if (queryString !== "") {
    url += queryString;
  }
  //console.log(url);
  window.history.replaceState({}, "", url);
}

if (utmSource && utmMedium && utmCampaign) {
  appendUTMToURL(utmParamsFromCookies);
}
$(document).ready(function () {
  var hostname = window.location.hostname;
  var link = `https://${hostname}/cart.json`;

  async function getData() {
    let x = await fetch(link);
    const data = await x.json();
    return data;
  }

  $(document).on(
    "click",
    "button[data-event-name='AddToCart'],.cart__item--qty .js-qty__adjust--minus,.cart__item--qty .js-qty__adjust--plus,.slidecarthq .remove",
    function () {
      setTimeout(function () {
        getData().then((data) => {
          console.log(data);
          var cartItems = data.items;
          var cartItemsLength = cartItems.length;
          console.log(cartItemsLength);
          if (cartItemsLength > 0) {
            $(".custom_cart_count").html(cartItemsLength);
            // $(".custom_cart_count").show();
          } else {
            $(".custom_cart_count").html(0);
          }
        });
      }, 3000);
    }
  );

  $(document).on("change", ".cart__item--qty .js-qty__num", function () {
    setTimeout(function () {
      getData().then((data) => {
        console.log(data);
        var cartItems = data.items;
        var cartItemsLength = cartItems.length;
        console.log(cartItemsLength);
        if (cartItemsLength > 0) {
          $(".custom_cart_count").html(cartItemsLength);
          // $(".custom_cart_count").show();
        }
      });
    }, 3000);
  });

  const alphaOnly = document.querySelectorAll(
    "form.contact-form input[name='contact[name]']"
  );
  alphaOnly.forEach(function (element) {
    element.addEventListener("beforeinput", function (event) {
      if (event.inputType === "deleteContentBackward") {
        return;
      }
      var value = this.value;
      if (
        !/^[a-zA-Z ]$/.test(event.data) ||
        (event.data === " " && value.length === 0)
      ) {
        event.preventDefault();
      }
    });
  });

  document
    .querySelector('form.contact-form input[name="contact[body]"]')
    .addEventListener("beforeinput", function (event) {
      if (event.inputType === "deleteContentBackward") {
        return;
      }
      var value = this.value;
      if (event.data === " " && value.length === 0) {
        event.preventDefault();
      }
    });
});
